import {
  AlertCircle,
  CheckCircle2,
  Clock,
  XCircle,
  type LucideIcon,
} from 'lucide-react'

export type ActionItemStatus = 'OPEN' | 'IN_PROGRESS' | 'RESOLVED' | 'CLOSED'
export type ActionItemPriority = 'CRITICAL' | 'HIGH' | 'MEDIUM' | 'LOW'

export const STATUS_STYLES: Record<ActionItemStatus, string> = {
  OPEN: 'border-amber-200 bg-amber-50 text-amber-700',
  IN_PROGRESS: 'border-blue-200 bg-blue-50 text-blue-700',
  RESOLVED: 'border-green-200 bg-green-50 text-green-700',
  CLOSED: 'border-gray-200 bg-gray-100 text-gray-500',
}

export const PRIORITY_STYLES: Record<ActionItemPriority, string> = {
  CRITICAL: 'border-red-300 bg-red-100 text-red-800',
  HIGH: 'border-orange-200 bg-orange-50 text-orange-700',
  MEDIUM: 'border-blue-200 bg-blue-50 text-blue-700',
  LOW: 'border-gray-200 bg-gray-50 text-gray-600',
}

export const STATUS_ICONS: Record<ActionItemStatus, LucideIcon> = {
  OPEN: AlertCircle,
  IN_PROGRESS: Clock,
  RESOLVED: CheckCircle2,
  CLOSED: XCircle,
}

export const isClosedStatus = (status: string): boolean =>
  status === 'RESOLVED' || status === 'CLOSED'

export const isOverdue = (item: {
  status: string
  dueDate?: string | null
}): boolean => {
  if (!item.dueDate) return false
  if (isClosedStatus(item.status)) return false
  return new Date(item.dueDate).getTime() < Date.now()
}
